import Breadcrumb from "components/Common/Breadcrumb"
import SubmitLoader from "components/Common/submitLoader"
import InvoiceWhatsAppCell from "components/InvoiceWhatsAppCell"
import { createUser, extendTrialByAdmin, getAllUser, getReferralDetails, updateUser } from "helpers/backendHelpers/user"
import { SimpleStringValue } from "helpers/common_helper_functions"
import { useFormik } from "formik"
import * as Yup from "yup"
import React, { useEffect, useMemo, useState } from "react"
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Container,
  Button,
  Badge,
  Table,
  Spinner,
} from "reactstrap"
import { CITIES_STATE } from "util/cities"
import dayjs from "dayjs"
import DynamicTable from "components/Common/DynamicTable"
import { getAllPlans } from "helpers/backendHelpers/plan"
import Select from "react-select"
import { createAddonPurchase, createSubscriptionV2, getAddonCatalog, getSubscriptionInfoV2, getUserAddons, grantWhatsappTrial, grantJobManagementTrial } from "helpers/backendHelpers/manageSubscription"
import { SaveToast } from "components/Common/SaveToast"
import { Checkbox } from "rsuite"
import { getAllFirms, restoreFirm } from "helpers/backendHelpers/firm"


// Multi-year add-ons are sold for 1 or 3 years only.
const ADDON_YEAR_OPTIONS = [1, 3]

const User = () => {
  const [users, setUsers] = useState([])
  const [plan, setPlan] = useState([])
  const [firm, setFirm] = useState([])
  const [category, setCategory] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [subscriptionModal, setSubscriptionModal] = useState(false)
  const [addonModal, setAddonModal] = useState(false)
  const [restoreFirmModal, setRestoreFirmModal] = useState(false)
  const [referralModal, setReferralModal] = useState(false)
  const [referralDetails, setReferralDetails] = useState(null)
  const [referralLoading, setReferralLoading] = useState(false)
  const [save, setSave] = useState(false)
  const [city, setCity] = useState(CITIES_STATE)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalRecords, setTotalRecords] = useState(0)
  const [search, setSearch] = useState("");
  const [addSubscriptionData, setAddSubscriptionData] = useState({
    userId: null,
    planId: null,
    paymentMode: "cash",
    isDiscountApplied: false,
    couponCode: null,
    invoiceFirmId: null,
    activeFirmIds: [],
  })
  const [currentUserData, setCurrentUserData] = useState(null)
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(null)
  const [subscriptionPriceDetails, setSubscriptionPriceDetails] = useState(null)
  const [subscriptionPriceLoading, setSubscriptionPriceLoading] = useState(false)
  const [subscriptionPriceError, setSubscriptionPriceError] = useState("")
  const [addonCatalog, setAddonCatalog] = useState([])
  const [addonForm, setAddonForm] = useState({
    userId: null,
    firmId: null,
    paymentMode: "cash",
    addons: [],
    creditPurchases: [],
    isAddonDiscountApplied: false,
    addonCouponCode: null,
  })
  const [selectedAddonId, setSelectedAddonId] = useState("")
  const [selectedAddonDurationDays, setSelectedAddonDurationDays] = useState("")
  const [selectedAddonPrice, setSelectedAddonPrice] = useState("")
  const [selectedAddonYears, setSelectedAddonYears] = useState(1)
  const [selectedAddonApplyFreeMonths, setSelectedAddonApplyFreeMonths] = useState(false)
  const [selectedCreditAddonId, setSelectedCreditAddonId] = useState("")
  const [selectedCreditQty, setSelectedCreditQty] = useState("")
  const [selectedCreditPrice, setSelectedCreditPrice] = useState("")
  const [restoreFirmUserId, setRestoreFirmUserId] = useState(null)
  const [restoreFirmLoadingId, setRestoreFirmLoadingId] = useState(null)
  const [activeUserAddons, setActiveUserAddons] = useState([])
  const [whatsappCatalogForm, setWhatsappCatalogForm] = useState(null)
  const [jobManagementCatalogForm, setJobManagementCatalogForm] = useState(null)
  const [jobManagementTrialDays, setJobManagementTrialDays] = useState(15)
  const [expirationType, setExpirationType] = useState("")

  // Free-months offer for the selected plan; eligibility and months come from the backend.
  const freeMonthsOffer = useMemo(() => {
    const offer = subscriptionPriceDetails?.freeMonthsOffer
    if (!offer?.enabled || !offer.freeMonths || !selectedPlanDetails) return null
    return offer
  }, [subscriptionPriceDetails, selectedPlanDetails])

  const isActiveFirmSelectionRequired = useMemo(() => {
    return selectedPlanDetails && selectedPlanDetails.noOfAllowedGST < firm.length;
  }, [selectedPlanDetails, firm]);

  const isFirmSelectionValid = useMemo(() => {
    return !isActiveFirmSelectionRequired ||
      ((addSubscriptionData.activeFirmIds || []).length === selectedPlanDetails.noOfAllowedGST);
  }, [isActiveFirmSelectionRequired, addSubscriptionData.activeFirmIds, selectedPlanDetails]);

  const invoiceFirms = useMemo(() => {
    return (firm || []).filter(f => f.isActive === true && f.isDeleted !== true);
  }, [firm]);

  useEffect(() => {
    document.title = "User | React Admin & User Template"
    fetchAllUser()
  }, [save, pageIndex, pageSize])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      userName: "",
      password: "",
      mobileNo: "",
      state: "",
      city: "",
    },
    validationSchema: Yup.object({
      userName: Yup.string().required("Please Enter user name"),
      password: Yup.string().required("Please Enter password"),
      mobileNo: Yup.string()
        .min(10)
        .max(10)
        .matches(/^[6-9]\d{9}$/, "Do not start value in 1,2,3,4,5")
        .required("Please Enter mobile number"),
    }),
    onSubmit: values => {
      handleAddUser(values)
    },
  })

  const today = dayjs().format("DD-MM-YYYY")
  const tomorrow = dayjs().add(1, "day").format("DD-MM-YYYY")
  const yesterday = dayjs().subtract(1, "day").format("DD-MM-YYYY")

  //* fetch all user
  const fetchAllUser = async (searchStr, expType) => {
    try {
      setLoading(true)
      const activeSearch = searchStr !== undefined ? searchStr : search;
      const activeExpType = expType !== undefined ? expType : expirationType;
      
      const params = { 
        page: pageIndex + 1, 
        limit: pageSize, 
        search: activeSearch, 
        expirationType: activeExpType 
      }
      let response = await getAllUser(params)
      setTotalRecords(response?.payload?.count)
      response = response?.payload?.data

      setUsers(response)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleViewReferral = async userId => {
    try {
      setReferralLoading(true)
      setReferralDetails(null)
      setReferralModal(true)
      const response = await getReferralDetails(userId)
      setReferralDetails(response?.payload || null)
    } catch (error) {
      setReferralModal(false)
      window.alert(error?.response?.data?.message || error?.message || "Failed to fetch referral details.")
    } finally {
      setReferralLoading(false)
    }
  }

  const referralToggle = () => {
    setReferralModal(!referralModal)
    if (referralModal) setReferralDetails(null)
  }


  //* handle update status
  const handleUpdateUserStatus = async (id, status) => {
    try {
      setLoading(true)
      await updateUser(id, { isActive: status })
      setSave(!save)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const toggle = () => {
    setModal(!modal)
  }

  const subscriptionToggle = (user = null) => {
    if (user) {
      setCurrentUserData(user)
      setAddSubscriptionData({
        userId: user._id,
        planId: null,
        paymentMode: "cash",
        isDiscountApplied: false,
        couponCode: null,
        invoiceFirmId: null,
        activeFirmIds: [],
      })
      setSelectedPlanDetails(null)
      setSubscriptionPriceDetails(null)
      setSubscriptionPriceError("")
    }
    setSubscriptionModal(!subscriptionModal)
  }

  const addonToggle = (userId = null) => {
    if (userId) {
      setAddonForm({
        userId,
        firmId: null,
        paymentMode: "cash",
        addons: [],
        creditPurchases: [],
        isAddonDiscountApplied: false,
        addonCouponCode: null,
      })
      setSelectedAddonId("")
      setSelectedAddonDurationDays("")
      setSelectedAddonPrice("")
      setSelectedAddonYears(1)
      setSelectedCreditAddonId("")
      setSelectedCreditQty("")
      setSelectedCreditPrice("")
    }
    setAddonModal(!addonModal)
  }

  const restoreFirmToggle = async (userId = null) => {
    const nextState = !restoreFirmModal

    if (nextState && userId) {
      setRestoreFirmUserId(userId)
      await fetchFirms(userId, { hydrateSelection: false })
    }

    if (!nextState) {
      setRestoreFirmUserId(null)
      setRestoreFirmLoadingId(null)
    }

    setRestoreFirmModal(nextState)
  }
  //* handle add click
  const handleAddButtonClick = () => {
    toggle()
  }

  const handleSubscriptionModalClick = (user) => {
    subscriptionToggle(user)
  }

  const handleAddonModalClick = (userId) => {
    addonToggle(userId)
  }

  const handleRestoreFirmModalClick = async (userId) => {
    await restoreFirmToggle(userId)
  }

  const handleExtendTrial = async (userId) => {
    const rawDays = window.prompt("Enter extension days (1-7):", "1")
    if (!rawDays) return

    const days = Number(rawDays)
    if (!Number.isInteger(days) || days < 1 || days > 7) {
      window.alert("Please enter a valid number between 1 and 7.")
      return
    }

    try {
      setSubmitLoading(true)
      const response = await extendTrialByAdmin(userId, days)
      window.alert(response?.message || "Trial extended successfully.")
      fetchAllUser(search || "")
    } catch (error) {
      window.alert(error?.response?.data?.message || error.message || "Failed to extend trial.")
    } finally {
      setSubmitLoading(false)
    }
  }

  const handleAddUser = async data => {
    data["platform"] = "web"
    data["role"] = "user"
    data["createdByAdmin"] = true
    data.mobileNo = data.mobileNo.toString()
    try {
      setSubmitLoading(true)
      await createUser(data)
      toggle()
      validation.resetForm()
      setSave(!save)
      setSubmitLoading(false)
    } catch (error) {
      setSubmitLoading(false)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "User name",
        accessor: "userName",
        filterable: true,
        Cell: cellProps => {
          const user = cellProps.row.original
          return (
            <div>
              <SimpleStringValue {...cellProps} />
              <Button color="primary" outline size="sm" className="d-block mt-1" onClick={() => handleViewReferral(user._id)}>
                View Referral
              </Button>
            </div>
          )
        },
      },
      {
        Header: "Mobile number",
        accessor: "mobileNo",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Referral Code",
        accessor: "referralCode",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Registration Date",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          return dayjs(cellProps.row.original.createdAt).format("DD-MM-YYYY")
        },
      },
      {
        Header: "Bill",
        accessor: "billCount",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Expiry Date",
        accessor: "planExpiryDate",
        filterable: true,
        Cell: cellProps => {
          // show also expiry yesterday , today , tommorow
          const data = cellProps?.row?.original?.planExpiryDate
          const expiryDate = dayjs(data).format("DD-MM-YYYY")
          const trialExtensionDays = cellProps?.row?.original?.subscriptionData?.trialExtensionDays || 0

          const extensionBadge = trialExtensionDays > 0 && (
            <div className="text-warning small mt-1">Extended: {trialExtensionDays} day(s)</div>
          )

          if (data) {
            if (expiryDate === today) {
              return (
                <>
                  <span className="badge bg-success">Plan Expiring today</span>
                  {extensionBadge}
                </>
              )
            } else if (expiryDate === tomorrow) {
              return (
                <>
                  <span className="badge bg-warning">Plan Expiring tomorrow</span>
                  {extensionBadge}
                </>
              )
            } else if (expiryDate === yesterday) {
              return (
                <>
                  <span className="badge bg-danger">Plan Expired yesterday</span>
                  {extensionBadge}
                </>
              )
            } else {
              return (
                <>
                  {expiryDate}
                  {extensionBadge}
                </>
              )
            }
          } else {
            return "-"
          }
        },
      },
      {
        Header: "Add-on Expiry",
        accessor: "activeAddons",
        disableFilters: true,
        Cell: cellProps => {
          const addons = cellProps.row.original.activeAddons || []
          if (addons.length === 0) return "-"
          return (
            <div style={{ minWidth: "160px" }}>
              {addons.map((addon, idx) => {
                const isPaused = addon.status === "paused"
                const isExpired = addon.status === "expired" || (!isPaused && dayjs(addon.expiryDate).isBefore(dayjs()))

                return (
                  <div key={idx} className={idx !== 0 ? "mt-2 border-top pt-1" : ""}>
                    <div className="fw-semibold mb-1" style={{ fontSize: "0.8rem" }}>
                      {addon.name || "Add-on"}
                    </div>
                    <div className="d-flex align-items-center mb-1">
                      <span 
                        className={`badge bg-soft-${addon.status === 'active' ? 'success' : addon.status === 'paused' ? 'warning' : 'danger'} text-${addon.status === 'active' ? 'success' : addon.status === 'paused' ? 'warning' : 'danger'} me-2`} 
                        style={{ fontSize: '0.65rem' }}
                      >
                        {addon.status.charAt(0).toUpperCase() + addon.status.slice(1)}
                      </span>
                    </div>
                    <div style={{ fontSize: "0.75rem", lineHeight: "1.2" }}>
                      {isPaused && addon.pausedAt ? (
                        <>
                          <div className="text-muted small">Paused: {dayjs(addon.pausedAt).format("DD-MM-YYYY")}</div>
                          <div className="text-muted small">Exp: {dayjs(addon.expiryDate).format("DD-MM-YYYY")}</div>
                        </>
                      ) : (
                        <div className={`text-${isExpired ? 'danger' : 'muted'} small`}>
                          {isExpired ? 'Expired: ' : 'Exp: '}{dayjs(addon.expiryDate).format("DD-MM-YYYY")}
                        </div>
                      )}
                    </div>
                    
                    {addon.hasCredits && (
                      <div className="text-info fw-bold mt-1" style={{ fontSize: "0.75rem" }}>Credits: {addon.creditsAvailable}</div>
                    )}
                  </div>
                )
              })}
            </div>
          )
        },
      },
      {
        Header: "Invoice Send",
        accessor: "latestPlanInvoicePayment.invoiceWhatsAppStatus",
        disableFilters: true,
        Cell: cellProps => {
          const user = cellProps.row.original
          const hasPlanInvoice = Boolean(user.latestPlanInvoicePayment)
          const hasAddonInvoice = Boolean(user.latestAddonInvoicePayment)
          if (!hasPlanInvoice && !hasAddonInvoice) return "-"
          return (
            <div className="d-flex flex-column gap-2" style={{ minWidth: "150px" }}>
              {hasPlanInvoice && (
                <div>
                  <div className="small fw-semibold mb-1">Plan Invoice</div>
                  <InvoiceWhatsAppCell
                    payment={user.latestPlanInvoicePayment}
                    onSent={() => fetchAllUser()}
                  />
                </div>
              )}
              {hasAddonInvoice && (
                <div className={hasPlanInvoice ? "border-top pt-2" : ""}>
                  <div className="small fw-semibold mb-1">Add-on Invoice</div>
                  <InvoiceWhatsAppCell
                    payment={user.latestAddonInvoicePayment}
                    onSent={() => fetchAllUser()}
                  />
                </div>
              )}
            </div>
          )
        },
      },
      {
        Header: "Status",
        accessor: "isActive",
        disableFilters: true,
        Cell: cellProps => {
          const cellData = cellProps.row.original
          return (
            <div className="form-check form-switch form-switch-md">
              <input
                type="checkbox"
                className="form-check-input"
                id={`status_checkbox-${cellData._id}`}
                name={`status_checkbox-${cellData._id}`}
                defaultChecked={cellData.isActive}
                onChange={e => {
                  let { checked, name } = e.target
                  document.getElementById(name).checked = checked
                  return handleUpdateUserStatus(cellData._id, checked)
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "",
        accessor: "Actions",
        disableFilters: true,
        Cell: cellProps => {
          const cellData = cellProps.row.original

          return (
            <div className="text-end">
              <Button color="primary" outline onClick={() => handleSubscriptionModalClick(cellData)}>Add Subscription</Button>
              <Button color="success" outline className="ms-2" onClick={() => handleAddonModalClick(cellData?._id)}>Add Add-on</Button>
              <Button color="info" outline className="ms-2" onClick={() => handleRestoreFirmModalClick(cellData?._id)}>Restore Firm</Button>
              <Button color="warning" outline className="ms-2" onClick={() => handleExtendTrial(cellData?._id)}>Extend Trial</Button>
            </div>
          )
        },
      },
    ],
    []
  )

  const fetchPlans = async () => {
    try {
      let response = await getAllPlans()
      response = response?.payload?.data
      setPlan(response)
    } catch (error) {
    }
  }

  const fetchFirms = async (userId, options = {}) => {
    const { hydrateSelection = true } = options
    try {
      let response = await getAllFirms(userId)
      response = response?.payload?.data
      setFirm(response)
      if (hydrateSelection) {
        const activeFirms = (response || []).filter(f => f.isActive === true && f.isDeleted !== true);
        setAddSubscriptionData(prev => ({ ...prev, invoiceFirmId: activeFirms[0]?._id || null }));
        setAddonForm(prev => ({ ...prev, firmId: response[0]?._id || null }))
      }
    } catch (error) {
    }
  }

  const handleRestoreFirm = async (firmId) => {
    try {
      setRestoreFirmLoadingId(firmId)
      await restoreFirm(firmId)
      await fetchFirms(restoreFirmUserId, { hydrateSelection: false })
      fetchAllUser(search || "")
    } catch (error) {
    } finally {
      setRestoreFirmLoadingId(null)
    }
  }

  const fetchAddonCatalogData = async () => {
    try {
      let response = await getAddonCatalog()
      response = response?.payload || []
      setAddonCatalog(response)
      const whatsappAddon = response.find(item => item.code === "whatsappService")
      setWhatsappCatalogForm(whatsappAddon ? {
        _id: whatsappAddon._id,
        price: whatsappAddon.price || 0,
        defaultDurationDays: whatsappAddon.defaultDurationDays || 365,
        description: whatsappAddon.description || "",
        isActive: whatsappAddon.isActive !== false
      } : null)
      const jobManagementAddon = response.find(item => item.code === "jobManagement")
      setJobManagementCatalogForm(jobManagementAddon ? { _id: jobManagementAddon._id } : null)
    } catch (error) {
    }
  }

  const fetchUserAddonsData = async (userId) => {
    try {
      let response = await getUserAddons(userId)
      response = response?.payload || []
      setActiveUserAddons(response)
    } catch (error) {
    }
  }

  const handleGrantWhatsappTrial = async () => {
    if (!addonForm.userId) return
    setSubmitLoading(true)
    try {
      await grantWhatsappTrial(addonForm.userId)
      await fetchUserAddonsData(addonForm.userId)
      setSave(!save)
    } catch (error) {
      // Expected 400 responses (no paid base plan, trial already used, or
      // active add-on) are shown as toasts by the shared API helper.
      console.error("WhatsApp trial grant failed:", error?.response?.data?.message || error?.message)
    } finally {
      setSubmitLoading(false)
    }
  }

  const handleGrantJobManagementTrial = async () => {
    if (!addonForm.userId) return
    const days = Number(jobManagementTrialDays)
    if (!Number.isInteger(days) || days < 1 || days > 15) {
      SaveToast({ message: "Trial days must be between 1 and 15", type: "error" })
      return
    }
    setSubmitLoading(true)
    try {
      await grantJobManagementTrial(addonForm.userId, days)
      await fetchUserAddonsData(addonForm.userId)
      setSave(!save)
    } catch (error) {
      console.error("Job Management trial grant failed:", error?.response?.data?.message || error?.message)
    } finally {
      setSubmitLoading(false)
    }
  }

  const addSubscription = async () => {
    if (!addSubscriptionData.planId) {
      window.alert("Please select a plan category.")
      return
    }
    const hasActiveFirms = invoiceFirms.length > 0;
    if (hasActiveFirms && !addSubscriptionData.invoiceFirmId) {
      window.alert("Please select a firm to create invoice.")
      return
    }
    if (isActiveFirmSelectionRequired && !isFirmSelectionValid) {
      window.alert(`Please select exactly ${selectedPlanDetails.noOfAllowedGST} active firm(s).`)
      return
    }

    try {
      setSubmitLoading(true)
      const payload = { ...addSubscriptionData }
      if (!freeMonthsOffer || !payload.applyFreeMonths) {
        delete payload.applyFreeMonths
      }
      if (!payload.invoiceFirmId) {
        delete payload.invoiceFirmId
      }
      let response = await createSubscriptionV2(payload)
      if (response && response.success) {
        setSubmitLoading(false)
        subscriptionToggle()
        fetchAllUser(search || "")
      }
    } catch (error) {
      setSubmitLoading(false)
      const errorMsg = error?.response?.data?.message || error?.message || "Something went wrong"
      window.alert(errorMsg)
    }
  }

  useEffect(() => {
    if (subscriptionModal) {
      fetchPlans()
      fetchFirms(addSubscriptionData.userId);
    }
  }, [subscriptionModal])

  useEffect(() => {
    if (!subscriptionModal || !addSubscriptionData.userId || !addSubscriptionData.planId) {
      setSubscriptionPriceDetails(null)
      setSubscriptionPriceError("")
      return
    }

    let active = true
    const fetchSubscriptionPrice = async () => {
      setSubscriptionPriceLoading(true)
      setSubscriptionPriceError("")
      try {
        const response = await getSubscriptionInfoV2(addSubscriptionData.planId, { userId: addSubscriptionData.userId })
        if (!active) return
        if (response?.success) {
          setSubscriptionPriceDetails(response.payload || null)
        } else {
          setSubscriptionPriceDetails(null)
          setSubscriptionPriceError(response?.message || "Unable to calculate subscription amount")
        }
      } catch (error) {
        if (!active) return
        setSubscriptionPriceDetails(null)
        setSubscriptionPriceError(error?.response?.data?.message || error?.message || "Unable to calculate subscription amount")
      } finally {
        if (active) setSubscriptionPriceLoading(false)
      }
    }

    fetchSubscriptionPrice()
    return () => { active = false }
  }, [subscriptionModal, addSubscriptionData.userId, addSubscriptionData.planId])

  useEffect(() => {
    if (addonModal) {
      fetchFirms(addonForm.userId)
      fetchAddonCatalogData()
      fetchUserAddonsData(addonForm.userId)
    }
  }, [addonModal])

  const addAddonSubscriptionItem = () => {
    if (!selectedAddonId || !selectedAddonDurationDays || selectedAddonPrice === "") return
    const addon = addonCatalog.find(a => a._id === selectedAddonId)
    const isAnnualMultiYearAddon = ["whatsappService", "jobManagement"].includes(addon?.code)
    setAddonForm(prev => ({
      ...prev,
      addons: [
        ...prev.addons,
        {
          addonId: selectedAddonId,
          durationDays: Number(selectedAddonDurationDays),
          price: Number(selectedAddonPrice),
          ...(isAnnualMultiYearAddon ? { years: Number(selectedAddonYears) || 1 } : {}),
          ...(isAnnualMultiYearAddon && selectedAddonApplyFreeMonths && selectedAddonFreeMonths > 0
            ? { applyFreeMonths: true, freeMonths: selectedAddonFreeMonths }
            : {}),
        }
      ]
    }))
    setSelectedAddonId("")
    setSelectedAddonDurationDays("")
    setSelectedAddonPrice("")
    setSelectedAddonYears(1)
    setSelectedAddonApplyFreeMonths(false)
  }

  const addAddonCreditItem = () => {
    if (!selectedCreditAddonId || !selectedCreditQty || selectedCreditPrice === "") return
    setAddonForm(prev => ({
      ...prev,
      creditPurchases: [
        ...prev.creditPurchases,
        {
          addonId: selectedCreditAddonId,
          credits: Number(selectedCreditQty),
          price: Number(selectedCreditPrice),
        }
      ]
    }))
    setSelectedCreditAddonId("")
    setSelectedCreditQty("")
    setSelectedCreditPrice("")
  }

  const removeAddonSubscriptionItem = (index) => {
    setAddonForm(prev => ({
      ...prev,
      addons: prev.addons.filter((_, idx) => idx !== index)
    }))
  }

  const removeAddonCreditItem = (index) => {
    setAddonForm(prev => ({
      ...prev,
      creditPurchases: prev.creditPurchases.filter((_, idx) => idx !== index)
    }))
  }

  const saveAddonPurchase = async () => {
    try {
      setSubmitLoading(true)
      const payload = {
        userId: addonForm.userId,
        firmId: addonForm.firmId,
        paymentMode: addonForm.paymentMode,
        addons: addonForm.addons,
        creditPurchases: addonForm.creditPurchases,
        isDiscountApplied: addonForm.isAddonDiscountApplied,
        couponCode: addonForm.isAddonDiscountApplied ? addonForm.addonCouponCode : null,
      }
      const response = await createAddonPurchase(payload)
      if (response?.success) {
        setSubmitLoading(false)
        addonToggle()
        SaveToast({ message: "Add-on purchase saved successfully", type: 'success' })
        setSave(!save)
      } else {
        setSubmitLoading(false)
        SaveToast({ message: response?.message || "Failed to save add-on purchase", type: 'error' })
      }
    } catch (error) {
      setSubmitLoading(false)
    }
  }

  useEffect(() => {
    if (search === "") {
      fetchAllUser()
    }
  }, [search])

  const selectedAddonIsAnnualMultiYear = ["whatsappService", "jobManagement"].includes(addonCatalog.find(a => a._id === selectedAddonId)?.code)
  const selectedAddonFreeMonths = selectedAddonIsAnnualMultiYear
    ? addonCatalog.find(a => a._id === selectedAddonId)?.freeMonthsByYears?.[Number(selectedAddonYears)] || 0
    : 0
  const isWhatsappTrialVisible = whatsappCatalogForm && new Date() <= new Date("2026-08-31T23:59:59")
  const isWhatsappTrialUsed = activeUserAddons.some((item) => item.addonCode === "whatsappService" && item.hasUsedTrial)
  const isJobManagementTrialUsed = activeUserAddons.some((item) => item.addonCode === "jobManagement" && item.hasUsedTrial)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="User" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Input
                    style={{
                      right: 150,
                      position: "absolute",
                      width: "fit-content",
                    }}
                    type="select"
                    value={expirationType}
                    onChange={e => {
                      const val = e.target.value;
                      setExpirationType(val)
                      fetchAllUser(search, val)
                    }}
                  >
                    <option value="">Select Expiration </option>
                    <option value="today">Today</option>
                    <option value="tomorrow">Tomorrow</option>
                    <option value="yesterday">Yesterday</option>
                  </Input>
                  <DynamicTable
                    columns={columns}
                    data={users}
                    isLoading={loading}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    pageCount={Math.ceil(totalRecords / pageSize)}
                    canPreviousPage={pageIndex > 0}
                    canNextPage={pageIndex < Math.ceil(totalRecords / pageSize) - 1}
                    gotoPage={setPageIndex}
                    previousPage={() => setPageIndex(pageIndex - 1)}
                    nextPage={() => setPageIndex(pageIndex + 1)}
                    setPageSize={setPageSize}
                    state={{ pageIndex, pageSize }}
                    addButtonLabel={"Add User"}
                    handleAddButtonClick={handleAddButtonClick}
                    search={search}
                    handleSearchChange={(e) => {
                      setSearch(e.target.value)
                    }}
                    handleSearchClick={() => fetchAllUser(search || "")}
                    totalRecords={totalRecords}
                  />

                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={modal} toggle={toggle}>
            {submitLoading ? <SubmitLoader /> : <></>}
            <ModalHeader toggle={toggle} tag="h4">
              Add User
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col className="col-12 mb-2">
                    <Label className="form-label">
                      userName<span className="text-danger">*</span>
                    </Label>

                    <Input
                      name="userName"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.userName &&
                          validation.errors.userName
                          ? true
                          : false
                      }
                    />
                    {validation.touched.userName &&
                      validation.errors.userName ? (
                      <FormFeedback type="invalid">
                        {validation.errors.userName}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col className="col-12 mb-2">
                    <Label className="form-label">
                      Password<span className="text-danger">*</span>
                    </Label>

                    <Input
                      name="password"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.password &&
                          validation.errors.password
                          ? true
                          : false
                      }
                    />
                    {validation.touched.password &&
                      validation.errors.password ? (
                      <FormFeedback type="invalid">
                        {validation.errors.password}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col className="col-12 mb-2">
                    <Label className="form-label">
                      Mobile Number<span className="text-danger">*</span>
                    </Label>

                    <Input
                      name="mobileNo"
                      type="number"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.mobileNo &&
                          validation.errors.mobileNo
                          ? true
                          : false
                      }
                    />
                    {validation.touched.mobileNo &&
                      validation.errors.mobileNo ? (
                      <FormFeedback type="invalid">
                        {validation.errors.mobileNo}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xs={12} className="mb-2">
                    <Label>
                      State
                      <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="state"
                      className="form-control my-1"
                      onChange={e => {
                        const filterCity = CITIES_STATE.filter(value => {
                          return value.state == e.target.value
                        })
                        setCity(filterCity)
                        validation.handleChange(e)
                      }}
                    >
                      <option>Select State</option>
                      {CITIES_STATE.map(item => (
                        <option value={item.state} key={item.id}>
                          {item.state}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col xs={12} className="mb-3">
                    <Label>
                      City
                      <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      name="city"
                      className="form-control"
                      onChange={validation.handleChange}
                    >
                      <option>Select State</option>
                      {city.map(item => (
                        <option value={item.name} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button
                        size="md"
                        color="danger"
                        type="button"
                        // disabled={submitLoading}
                        className="mx-2"
                        onClick={() => {
                          toggle()
                          validation.resetForm()
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={subscriptionModal} toggle={subscriptionToggle}>
            <ModalHeader toggle={subscriptionToggle} tag="h4">
              Add Subscription
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >

                {/* Display User name and current plan */}
                <Row>
                  <Col className="col-12 mb-2">
                    Add Subscription for <b>{currentUserData?.userName}</b>
                    {currentUserData?.planName && (
                      <div className="text-muted small mt-1">
                        Current Plan: <b>{currentUserData.planName}</b> (Expires: {dayjs(currentUserData.planExpiryDate).format("DD-MM-YYYY")})
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        Plan<span className="text-danger">*</span>
                      </Label>

                      <Select
                        name="plan"
                        options={plan.map(p => ({ label: p.name, value: p.planCategories }))}
                        onChange={selectedOption => {
                          const selectedPlan = plan.find(p => p.planCategories === selectedOption.value);
                          const categories = selectedPlan.planCategories || [];
                          const defaultCat = categories[0]; // Set first category as default

                          setCategory(categories);
                          setSelectedPlanDetails(defaultCat || null);
                          setAddSubscriptionData(prev => ({
                            ...prev,
                            planId: defaultCat ? defaultCat._id : null,
                            activeFirmIds: []
                          }));
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        Categories<span className="text-danger">*</span>
                      </Label>

                      <Select
                        name="categories"
                        value={selectedPlanDetails ? {
                          label: `${selectedPlanDetails.planAmount} (${selectedPlanDetails.noOfAllowedGST} Firms) - ${selectedPlanDetails.noOfBillingCycle} ${selectedPlanDetails.noOfBillingCycle > 1 ? selectedPlanDetails.billingCycle : selectedPlanDetails.billingCycle.replace(/s$/, '')}`,
                          value: selectedPlanDetails._id
                        } : null}
                        options={category.map(c => ({
                          label: `${c.planAmount} (${c.noOfAllowedGST} Firms) - ${c.noOfBillingCycle} ${c.noOfBillingCycle > 1 ? c.billingCycle : c.billingCycle.replace(/s$/, '')}`,
                          value: c._id
                        }))}
                        onChange={selectedOption => {
                          const selectedCat = category.find(c => c._id === selectedOption.value);
                          setSelectedPlanDetails(selectedCat);
                          setAddSubscriptionData({ ...addSubscriptionData, planId: selectedOption.value, applyFreeMonths: false });
                        }}
                        isDisabled={category?.length === 0}
                      />
                    </div>
                  </Col>
                </Row>

                {freeMonthsOffer?.enabled && freeMonthsOffer.freeMonths > 0 && (
                  <Row>
                    <Col xxl={12}>
                      <div className="mb-3">
                        <Button
                          type="button"
                          color={addSubscriptionData.applyFreeMonths ? "success" : "outline-success"}
                          onClick={() => setAddSubscriptionData(prev => ({ ...prev, applyFreeMonths: !prev.applyFreeMonths }))}
                        >
                          <i className={`bx ${addSubscriptionData.applyFreeMonths ? "bx-check-circle" : "bx-gift"} me-1`}></i>
                          {addSubscriptionData.applyFreeMonths
                            ? `${freeMonthsOffer.freeMonths} month${freeMonthsOffer.freeMonths > 1 ? "s" : ""} free added`
                            : `Add ${freeMonthsOffer.freeMonths} month${freeMonthsOffer.freeMonths > 1 ? "s" : ""} free`}
                        </Button>
                        {addSubscriptionData.applyFreeMonths && (
                          <small className="text-success ms-2">
                            User will get {freeMonthsOffer.totalMonths} months in total
                          </small>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        Select Firm To Create Invoice <span className="text-danger">*</span>
                      </Label>

                      <Select
                        name="invoiceFirmId"
                        value={addSubscriptionData.invoiceFirmId ? {
                          label: invoiceFirms.find(f => f._id === addSubscriptionData.invoiceFirmId)?.firmName,
                          value: addSubscriptionData.invoiceFirmId
                        } : null}
                        options={invoiceFirms.map(f => ({ label: f.firmName, value: f._id }))}
                        onChange={selectedOption => {
                          setAddSubscriptionData({ ...addSubscriptionData, invoiceFirmId: selectedOption ? selectedOption.value : null });
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                {isActiveFirmSelectionRequired && (
                  <Row>
                    <Col xxl={12}>
                      <div className="mb-3">
                        <Label className="form-label text-danger">
                          Downgrade Detected: Select Active Firms (Max: {selectedPlanDetails.noOfAllowedGST})
                        </Label>
                        <div className="border p-3 rounded" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {firm.length === 0 ? (
                            <div className="text-muted">No firms found for this user.</div>
                          ) : (
                            firm.map(f => {
                              const isChecked = (addSubscriptionData.activeFirmIds || []).some(id => String(id) === String(f._id));
                              const limitReached = !isChecked && (addSubscriptionData.activeFirmIds || []).length >= (selectedPlanDetails.noOfAllowedGST || 0);

                              return (
                                <div
                                  key={f._id}
                                  className="d-flex align-items-center mb-2"
                                  style={{ cursor: limitReached ? 'default' : 'pointer' }}
                                  onClick={() => {
                                    if (limitReached && !isChecked) return;

                                    let currentIds = [...(addSubscriptionData.activeFirmIds || [])];
                                    if (isChecked) {
                                      currentIds = currentIds.filter(id => String(id) !== String(f._id));
                                    } else {
                                      currentIds.push(f._id);
                                    }
                                    setAddSubscriptionData({
                                      ...addSubscriptionData,
                                      activeFirmIds: currentIds
                                    });
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{ cursor: 'pointer' }}
                                    checked={isChecked}
                                    readOnly // Managed by parent div's onClick
                                    disabled={limitReached}
                                  />
                                  <span className={`ms-2 ${limitReached ? 'text-muted' : ''}`} style={{ userSelect: 'none' }}>
                                    {f.firmName} ({f.GSTNo || 'No GST'})
                                  </span>
                                </div>
                              );
                            })
                          )}
                        </div>
                        {selectedPlanDetails.noOfAllowedGST > 0 && (
                          <div className={`small mt-1 ${isFirmSelectionValid ? 'text-primary' : 'text-danger fw-bold'}`}>
                            Selected: {(addSubscriptionData.activeFirmIds || []).length} / {selectedPlanDetails.noOfAllowedGST}
                            {!isFirmSelectionValid && " (Please select exactly this many firms)"}
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        Discount Applied?<span className="text-danger">*</span>
                      </Label>

                      <Checkbox
                        name="isDiscountApplied"
                        value={addSubscriptionData.isDiscountApplied}
                        onChange={(value, checked) => {
                          setAddSubscriptionData({ ...addSubscriptionData, isDiscountApplied: checked })
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                {addSubscriptionData.isDiscountApplied &&
                  <Row>
                    <Col xxl={12}>
                      <div className="mb-3">
                        <Label className="form-label">
                          Coupon Code<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="couponCode"
                          type="text"
                          onChange={e => {
                            setAddSubscriptionData({ ...addSubscriptionData, couponCode: e.target.value })
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                }

                {subscriptionPriceLoading ? (
                  <div className="text-center py-2 mb-3"><Spinner color="primary" size="sm" /> <span className="text-muted small ms-2">Calculating payment amount...</span></div>
                ) : subscriptionPriceError ? (
                  <div className="alert alert-danger py-2 small mb-3">{subscriptionPriceError}</div>
                ) : subscriptionPriceDetails && (() => {
                  const baseAmount = Number(subscriptionPriceDetails.basePlanAmount || 0)
                  const planAmount = Number(subscriptionPriceDetails.planAmount || 0)
                  const balanceAdjustment = !subscriptionPriceDetails.advanceSubscription
                    ? Number(subscriptionPriceDetails.pendingAmount || 0)
                    : 0
                  const taxAmount = Number(subscriptionPriceDetails.taxAmount || 0)
                  const finalAmount = Number(subscriptionPriceDetails.finalAmount || 0)

                  return (
                    <div className="border rounded p-3 mb-3 bg-light">
                      <div className="text-muted small text-uppercase fw-bold mb-2">Order Summary</div>
                      <div className="d-flex justify-content-between mb-2"><span>Original Plan Amount</span><strong>₹{baseAmount.toFixed(2)}</strong></div>
                      {balanceAdjustment > 0 && <>
                        <div className="d-flex justify-content-between mb-2 text-danger"><span>Balance Adjustment</span><strong>- ₹{balanceAdjustment.toFixed(2)}</strong></div>
                        <div className="d-flex justify-content-between mb-2"><span>Plan Amount</span><strong>₹{planAmount.toFixed(2)}</strong></div>
                      </>}
                      <div className="d-flex justify-content-between mb-2"><span>GST (18%)</span><strong>+ ₹{taxAmount.toFixed(2)}</strong></div>
                      <div className="d-flex justify-content-between border-top pt-2 fs-5"><strong>Total Due</strong><strong className="text-success">₹{finalAmount.toFixed(2)}</strong></div>
                      {addSubscriptionData.isDiscountApplied && <div className="small text-muted mt-2">Coupon discount will be validated and applied when you save the subscription.</div>}
                    </div>
                  )
                })()}



                <Row>
                  <Col className="mb-3">
                    <Label>Payment Mode</Label> <br />
                    <Input
                      name="paymentMode"
                      type="radio"
                      onChange={e => setAddSubscriptionData({ ...addSubscriptionData, paymentMode: e.target.value })}
                      defaultChecked={true}
                      value={"cash"}
                    />
                    <Label className="mx-3">Cash</Label>
                    <Input
                      name="paymentMode"
                      type="radio"
                      onChange={e => setAddSubscriptionData({ ...addSubscriptionData, paymentMode: e.target.value })}
                      defaultChecked={false}
                      value={"online"}
                    />
                    <Label className="mx-3">Online</Label>
                    <Input
                      name="paymentMode"
                      type="radio"
                      onChange={e => setAddSubscriptionData({ ...addSubscriptionData, paymentMode: e.target.value })}
                      defaultChecked={false}
                      value={"free"}
                    />
                    <Label className="mx-3">Free</Label>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button
                        size="md"
                        color="danger"
                        type="button"
                        disabled={submitLoading}
                        className="mx-2"
                        onClick={() => {
                          subscriptionToggle()
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn btn-success save-user"
                        onClick={addSubscription}
                        disabled={submitLoading || !addSubscriptionData.planId || (invoiceFirms.length > 0 && !addSubscriptionData.invoiceFirmId) || !isFirmSelectionValid}
                      >
                        {"Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={addonModal} toggle={addonToggle} size="lg">
            <ModalHeader toggle={addonToggle} tag="h4">
              Add Add-on
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={e => e.preventDefault()}>
                <Row>
                  <Col className="col-12 mb-3">
                    Add Add-on for <b>{users.find(user => user._id === addonForm.userId)?.userName}</b>
                  </Col>
                </Row>

                {(isWhatsappTrialVisible || jobManagementCatalogForm) && (
                  <Row className="mb-4 g-3">
                    {isWhatsappTrialVisible && (
                      <Col md={6}>
                      <div className="border rounded p-3 bg-light h-100 d-flex align-items-center">
                        <div className="d-flex justify-content-between align-items-center gap-2">
                          <Label className="fw-bold mb-0">WhatsApp Service Catalog</Label>
                          <Button color="info" size="sm" type="button" disabled={submitLoading || isWhatsappTrialUsed} onClick={handleGrantWhatsappTrial}>
                            {isWhatsappTrialUsed ? "Trial Already Used" : "Grant 15-Day Free Trial"}
                          </Button>
                        </div>
                      </div>
                      </Col>
                    )}
                    {jobManagementCatalogForm && (
                      <Col md={6}>
                      <div className="border rounded p-3 bg-light h-100 d-flex align-items-center">
                        <div className="d-flex align-items-center gap-2 flex-nowrap">
                          <Label className="fw-bold mb-0 text-nowrap">Job Work Catalog</Label>
                          <Input disabled={isJobManagementTrialUsed} style={{ width: 70, height: 32, minWidth: 70 }} type="number" min="1" max="15" value={jobManagementTrialDays} onChange={e => setJobManagementTrialDays(e.target.value)} />
                          <Button color="info" size="sm" style={{ height: 32, whiteSpace: 'nowrap', minWidth: 108 }} type="button" disabled={submitLoading || isJobManagementTrialUsed} onClick={handleGrantJobManagementTrial}>
                            {isJobManagementTrialUsed ? "Trial Used" : "Grant Free Trial"}
                          </Button>
                        </div>
                      </div>
                      </Col>
                    )}
                  </Row>
                )}

                {/* Display Current Active Add-ons */}
                {!!activeUserAddons.length && (
                  <Row className="mb-4">
                    <Col md={12}>
                      <Label className="form-label text-primary fw-bold" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>
                        <i className="mdi mdi-layers-outline me-1"></i> CURRENT ACTIVE ADD-ONS
                      </Label>
                      <div
                        className="rounded shadow-sm border-0"
                        style={{
                          maxHeight: '180px',
                          overflowY: 'auto',
                          background: '#f8f9fa',
                          padding: '10px'
                        }}
                      >
                        <Row className="g-2">
                          {activeUserAddons.map((item) => (
                            <Col key={item._id} xs={12} md={6}>
                              <div className="d-flex justify-content-between align-items-center h-100 p-2 bg-white rounded shadow-sm border-start border-3 border-success">
                                <div className="d-flex flex-column">
                                  <span className="fw-bold text-dark" style={{ fontSize: '0.95rem' }}>{item.addonName}</span>
                                  <div className="d-flex align-items-center mt-1">
                                    <span
                                      className={`badge bg-soft-${item.status === 'active' ? 'success' : item.status === 'paused' ? 'warning' : 'danger'} text-${item.status === 'active' ? 'success' : item.status === 'paused' ? 'warning' : 'danger'} me-2`}
                                      style={{ fontSize: '0.7rem' }}
                                    >
                                      {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                    </span>
                                    {item.isTrial && (
                                      <span
                                        className="badge bg-soft-info text-info me-2"
                                        style={{ fontSize: '0.7rem' }}
                                      >
                                        Trial
                                      </span>
                                    )}
                                    <span className="small text-muted" style={{ fontSize: '0.8rem' }}>
                                      <i className="mdi mdi-calendar-clock me-1"></i>
                                      {item.status === 'paused' && item.pausedAt
                                        ? (
                                          <span>
                                            Paused at: {dayjs(item.pausedAt).format("DD-MM-YYYY")}
                                            <span className="ms-2">| Exp: {dayjs(item.expiryDate).format("DD-MM-YYYY")}</span>
                                          </span>
                                        )
                                        : `Expires: ${dayjs(item.expiryDate).format("DD-MM-YYYY")}`}
                                    </span>
                                  </div>
                                </div>
                                {item.hasCredits && item.creditWallet && (
                                  <div className="text-end">
                                    <div className="fw-bold text-primary" style={{ fontSize: '1.1rem' }}>
                                      {item.creditWallet.creditsAvailable}
                                    </div>
                                    <div className="text-muted small" style={{ fontSize: '0.7rem', marginTop: '-4px' }}>
                                      Credits Left
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md={12} className="mb-3">
                    <Label className="form-label">
                      Select Firm <span className="text-danger">*</span>
                    </Label>
                    <Select
                      options={firm.map(f => ({ label: f.firmName, value: f._id }))}
                      value={firm.filter(f => f._id === addonForm.firmId).map(f => ({ label: f.firmName, value: f._id }))[0] || null}
                      onChange={selectedOption => setAddonForm(prev => ({ ...prev, firmId: selectedOption?.value || null }))}
                    />
                  </Col>
                </Row>

                <Row className="align-items-end">
                  <Col md={selectedAddonIsAnnualMultiYear ? 3 : 4} className="mb-3">
                    <Label className="form-label">Add-on</Label>
                    <Input type="select" value={selectedAddonId} onChange={e => {
                      const addonId = e.target.value
                      setSelectedAddonId(addonId)
                      const addon = addonCatalog.find(a => a._id === addonId)
                      const isAnnualMultiYearAddon = ["whatsappService", "jobManagement"].includes(addon?.code)
                      const baseDurationDays = addon?.defaultDurationDays || 365
                      const basePrice = addon?.hasCredits ? addon?.creditConfig?.pricePerUnit || 0 : addon?.price || 0
                      if (isAnnualMultiYearAddon) {
                        setSelectedAddonYears(1)
                        setSelectedAddonApplyFreeMonths(false)
                        setSelectedAddonDurationDays(baseDurationDays * 1)
                        setSelectedAddonPrice(basePrice * 1)
                      } else {
                        setSelectedAddonDurationDays(addon?.defaultDurationDays || "")
                        setSelectedAddonPrice(addon?.hasCredits ? addon?.creditConfig?.pricePerUnit || "" : addon?.price || "")
                      }
                    }}>
                      <option value="">Select Add-on</option>
                      {addonCatalog.map(addon => (
                        <option key={addon._id} value={addon._id}>{addon.name}</option>
                      ))}
                    </Input>
                  </Col>
                  {selectedAddonIsAnnualMultiYear && (
                    <Col md={2} className="mb-3">
                      <Label className="form-label">Years</Label>
                      <Input type="select" value={selectedAddonYears} onChange={e => {
                        const years = e.target.value
                        setSelectedAddonYears(years)
                        setSelectedAddonApplyFreeMonths(false)
                        const addon = addonCatalog.find(a => a._id === selectedAddonId)
                        const baseDurationDays = addon?.defaultDurationDays || 365
                        const basePrice = addon?.hasCredits ? addon?.creditConfig?.pricePerUnit || 0 : addon?.price || 0
                        const numYears = Number(years) || 0
                        setSelectedAddonDurationDays(numYears ? baseDurationDays * numYears : "")
                        setSelectedAddonPrice(numYears ? Number((basePrice * numYears).toFixed(2)) : "")
                      }}>
                        {ADDON_YEAR_OPTIONS.map(year => (
                          <option key={year} value={year}>{year} {year === 1 ? "Year" : "Years"}</option>
                        ))}
                      </Input>
                    </Col>
                  )}
                  <Col md={selectedAddonIsAnnualMultiYear ? 3 : 4} className="mb-3">
                    <Label className="form-label">Duration (Days)</Label>
                    <Input type="number" min="1" value={selectedAddonDurationDays} disabled />
                  </Col>
                  <Col md={3} className="mb-3">
                    <Label className="form-label">Price</Label>
                    <Input type="number" min="0" value={selectedAddonPrice} disabled />
                  </Col>
                  <Col md={1} className="mb-3">
                    <Button color="primary" type="button" onClick={addAddonSubscriptionItem}>+</Button>
                  </Col>
                </Row>
                {selectedAddonFreeMonths > 0 && (
                  <div className="mb-3">
                    <Button
                      type="button"
                      size="sm"
                      color={selectedAddonApplyFreeMonths ? "success" : "outline-success"}
                      onClick={() => setSelectedAddonApplyFreeMonths(prev => !prev)}
                    >
                      <i className={`bx ${selectedAddonApplyFreeMonths ? "bx-check-circle" : "bx-gift"} me-1`}></i>
                      {selectedAddonApplyFreeMonths
                        ? `${selectedAddonFreeMonths} month${selectedAddonFreeMonths > 1 ? "s" : ""} free added`
                        : `Add ${selectedAddonFreeMonths} month${selectedAddonFreeMonths > 1 ? "s" : ""} free`}
                    </Button>
                  </div>
                )}

                {!!addonForm.addons.length && (
                  <Row className="mb-3">
                    <Col md={12}>
                      {addonForm.addons.map((item, idx) => {
                        const addon = addonCatalog.find(a => a._id === item.addonId)
                        return (
                          <div key={`${item.addonId}-${idx}`} className="d-flex justify-content-between border rounded p-2 mb-2">
                            <div>
                              {addon?.name || "Add-on"} | {item.durationDays} days | Rs. {item.price}
                              {item.freeMonths > 0 && <span className="text-success ms-1">(+{item.freeMonths} month{item.freeMonths > 1 ? "s" : ""} free)</span>}
                            </div>
                            <Button color="danger" size="sm" onClick={() => removeAddonSubscriptionItem(idx)}>Remove</Button>
                          </div>
                        )
                      })}
                    </Col>
                  </Row>
                )}

                <Row className="align-items-end">
                  <Col md={4} className="mb-3">
                    <Label className="form-label">Credit Add-on</Label>
                    <Input type="select" value={selectedCreditAddonId} onChange={e => {
                      const addonId = e.target.value
                      setSelectedCreditAddonId(addonId)
                      const addon = addonCatalog.find(a => a._id === addonId)
                      const pricePerCredit = addon?.creditConfig?.pricePerCredit
                        || (addon?.creditConfig?.pricePerUnit / addon?.creditConfig?.creditsPerUnit)
                        || 0
                      setSelectedCreditPrice(selectedCreditQty ? Number((pricePerCredit * Number(selectedCreditQty)).toFixed(2)) : "")
                    }}>
                      <option value="">Select Add-on</option>
                      {addonCatalog.filter(addon => addon.hasCredits).map(addon => (
                        <option key={addon._id} value={addon._id}>{addon.name}</option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={3} className="mb-3">
                    <Label className="form-label">Credits</Label>
                    <Input type="number" min="1" value={selectedCreditQty} onChange={e => {
                      const qty = e.target.value
                      setSelectedCreditQty(qty)
                      const addon = addonCatalog.find(a => a._id === selectedCreditAddonId)
                      const pricePerCredit = addon?.creditConfig?.pricePerCredit
                        || (addon?.creditConfig?.pricePerUnit / addon?.creditConfig?.creditsPerUnit)
                        || 0
                      setSelectedCreditPrice(qty ? Number((pricePerCredit * Number(qty)).toFixed(2)) : "")
                    }} />
                  </Col>
                  <Col md={4} className="mb-3">
                    <Label className="form-label">Price</Label>
                    <Input type="number" min="0" value={selectedCreditPrice} disabled />
                  </Col>
                  <Col md={1} className="mb-3">
                    <Button color="primary" type="button" onClick={addAddonCreditItem}>+</Button>
                  </Col>
                </Row>

                {!!addonForm.creditPurchases.length && (
                  <Row className="mb-3">
                    <Col md={12}>
                      {addonForm.creditPurchases.map((item, idx) => {
                        const addon = addonCatalog.find(a => a._id === item.addonId)
                        return (
                          <div key={`${item.addonId}-credit-${idx}`} className="d-flex justify-content-between border rounded p-2 mb-2">
                            <div>{addon?.name || "Add-on"} | {item.credits} credits | Rs. {item.price}</div>
                            <Button color="danger" size="sm" onClick={() => removeAddonCreditItem(idx)}>Remove</Button>
                          </div>
                        )
                      })}
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col xxl={12}>
                    <div className="mb-3">
                      <Label className="form-label">
                        Addon Discount?<span className="text-danger">*</span>
                      </Label>

                      <Checkbox
                        name="isAddonDiscountApplied"
                        value={addonForm.isAddonDiscountApplied}
                        onChange={(value, checked) => {
                          setAddonForm(prev => ({ ...prev, isAddonDiscountApplied: checked }))
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                {addonForm.isAddonDiscountApplied &&
                  <Row>
                    <Col xxl={12}>
                      <div className="mb-3">
                        <Label className="form-label">
                          Coupon Code<span className="text-danger">*</span>
                        </Label>

                        <Input
                          name="addonCouponCode"
                          type="text"
                          onChange={e => {
                            setAddonForm(prev => ({ ...prev, addonCouponCode: e.target.value }))
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                }

                <Row>
                  <Col className="mb-3">
                    <Label>Payment Mode</Label> <br />
                    <Input
                      name="addonPaymentMode"
                      type="radio"
                      onChange={e => setAddonForm(prev => ({ ...prev, paymentMode: e.target.value }))}
                      checked={addonForm.paymentMode === "cash"}
                      value={"cash"}
                    />
                    <Label className="mx-3">Cash</Label>
                    <Input
                      name="addonPaymentMode"
                      type="radio"
                      onChange={e => setAddonForm(prev => ({ ...prev, paymentMode: e.target.value }))}
                      checked={addonForm.paymentMode === "online"}
                      value={"online"}
                    />
                    <Label className="mx-3">Online</Label>
                    <Input
                      name="addonPaymentMode"
                      type="radio"
                      onChange={e => setAddonForm(prev => ({ ...prev, paymentMode: e.target.value }))}
                      checked={addonForm.paymentMode === "cheque"}
                      value={"cheque"}
                    />
                    <Label className="mx-3">Cheque</Label>
                    <Input
                      name="addonPaymentMode"
                      type="radio"
                      onChange={e => setAddonForm(prev => ({ ...prev, paymentMode: e.target.value }))}
                      checked={addonForm.paymentMode === "other"}
                      value={"other"}
                    />
                    <Label className="mx-3">Other</Label>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <Button
                        size="md"
                        color="danger"
                        type="button"
                        disabled={submitLoading}
                        className="mx-2"
                        onClick={() => addonToggle()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn btn-success save-user"
                        onClick={saveAddonPurchase}
                        disabled={submitLoading || !addonForm.firmId || (!addonForm.addons.length && !addonForm.creditPurchases.length)}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={restoreFirmModal} toggle={() => restoreFirmToggle()} size="lg">
            <ModalHeader toggle={() => restoreFirmToggle()} tag="h4">
              Restore Firm
            </ModalHeader>
            <ModalBody>
              <Row className="mb-3">
                <Col className="col-12">
                  Restore firm for <b>{users.find(user => user._id === restoreFirmUserId)?.userName || "-"}</b>
                </Col>
              </Row>

              {!firm.length ? (
                <div className="text-muted">No firms found for this user.</div>
              ) : (
                <Table responsive bordered hover>
                  <thead>
                    <tr>
                      <th>Firm Name</th>
                      <th>GST No</th>
                      <th>Status</th>
                      <th className="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firm.map(item => (
                      <tr key={item._id}>
                        <td>{item.firmName || "-"}</td>
                        <td>{item.GSTNo || "-"}</td>
                        <td>
                          <Badge color={item.isActive ? "success" : "danger"}>
                            {item.isActive ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td className="text-end">
                          <Button
                            color="primary"
                            size="sm"
                            disabled={item.isActive || restoreFirmLoadingId === item._id}
                            onClick={() => handleRestoreFirm(item._id)}
                          >
                            {restoreFirmLoadingId === item._id ? "Restoring..." : "Restore"}
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}

              <Row>
                <Col>
                  <div className="text-end">
                    <Button
                      size="md"
                      color="danger"
                      type="button"
                      onClick={() => restoreFirmToggle()}
                    >
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          <Modal isOpen={referralModal} toggle={referralToggle} size="lg">
            <ModalHeader toggle={referralToggle} tag="h4">
              View Referral
            </ModalHeader>
            <ModalBody>
              {referralLoading ? (
                <div className="text-center text-muted py-4">Loading referral details...</div>
              ) : referralDetails?.user ? (
                <>
                  <Row className="mb-3">
                    <Col md="4">
                      <div className="text-muted small">Referral Code</div>
                      <div>{referralDetails.user.referralCode || "-"}</div>
                    </Col>
                    <Col md="4">
                      <div className="text-muted small">Referral Count</div>
                      <div>{referralDetails.user.referralCount || 0}</div>
                    </Col>
                    <Col md="4">
                      <div className="text-muted small">Referred By</div>
                      <div>{referralDetails.user.referredById?.userName || "-"}</div>
                    </Col>
                  </Row>

                  <div className="fw-semibold mb-2">Referred Users ({referralDetails.referredUsers?.length || 0})</div>
                  {referralDetails.referredUsers?.length ? (
                    <Table responsive bordered hover className="mb-0">
                      <thead>
                        <tr>
                          <th>User Name</th>
                          <th>Mobile Number</th>
                          <th>Referral Code</th>
                          <th>Registration Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {referralDetails.referredUsers.map(user => (
                          <tr key={user._id}>
                            <td>{user.userName || "-"}</td>
                            <td>{user.mobileNo || "-"}</td>
                            <td>{user.referralCode || "-"}</td>
                            <td>{user.createdAt ? dayjs(user.createdAt).format("DD-MM-YYYY") : "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted">No users have used this referral code yet.</div>
                  )}
                </>
              ) : (
                <div className="text-muted">Referral details are not available.</div>
              )}
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment >
  )
}

export default User
